import {ToolResult} from '../../copilot.types';

export default function toolResult(content: string): ToolResult {
  return {content};
}
